<template>
  <div class="space-y-3">
    <div class="mb-1">
      <div
        class="flex flex-wrap gap-3"
        role="radiogroup"
        aria-label="Fonte de dados"
      >
        <label
          :class="[
            'inline-flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm cursor-pointer transition',
            form.settings.data_analyst.data_source_kind === 'api_endpoint'
              ? 'border-cyan-400/50 bg-cyan-400/10 text-slate-100 ring-1 ring-cyan-400/25'
              : 'border-slate-500/80 bg-slate-800/55 text-slate-300 hover:border-slate-500'
          ]"
        >
          <input
            v-model="form.settings.data_analyst.data_source_kind"
            type="radio"
            value="api_endpoint"
            class="h-4 w-4 border-slate-500 bg-slate-800 text-cyan-400 focus:ring-2 focus:ring-cyan-400/40 focus:ring-offset-0 focus:ring-offset-transparent"
          />
          <span>Endpoint (API)</span>
        </label>
        <label
          :class="[
            'inline-flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm cursor-pointer transition',
            form.settings.data_analyst.data_source_kind === 'database_view'
              ? 'border-cyan-400/50 bg-cyan-400/10 text-slate-100 ring-1 ring-cyan-400/25'
              : 'border-slate-500/80 bg-slate-800/55 text-slate-300 hover:border-slate-500'
          ]"
        >
          <input
            v-model="form.settings.data_analyst.data_source_kind"
            type="radio"
            value="database_view"
            class="h-4 w-4 border-slate-500 bg-slate-800 text-cyan-400 focus:ring-2 focus:ring-cyan-400/40 focus:ring-offset-0 focus:ring-offset-transparent"
          />
          <span>View (base de dados)</span>
        </label>
      </div>
    </div>

    <AgentConnectorEndpoints
      v-if="form.settings.data_analyst.data_source_kind === 'api_endpoint'"
      :options="filteredApiEndpointOptions"
      :selected-id="selectedApiEndpointToAdd"
      :selected-ids="form.api_connector_endpoint_ids"
      :single="false"
      @update:selectedId="$emit('update:selectedApiEndpointToAdd', $event)"
      @add="$emit('add-api-endpoint')"
      @remove="$emit('remove-api-endpoint', $event)"
    />

    <AgentConnectorViews
      v-if="form.settings.data_analyst.data_source_kind === 'database_view'"
      :options="databaseConnectorViewOptions"
      :selected-id="selectedDatabaseConnectorViewToAdd"
      :selected-ids="form.database_connector_view_ids"
      :single="false"
      @update:selectedId="$emit('update:selectedDatabaseConnectorViewToAdd', $event)"
      @add="$emit('add-database-view')"
      @remove="$emit('remove-database-view', $event)"
    />

    <div class="rounded-md border border-slate-600/50 bg-slate-900/30 p-3 space-y-2">
      <label class="block text-xs font-medium text-slate-300">E-mails autorizados no chat</label>
      <input
        v-model="form.settings.outputs.chat_authorized_emails"
        type="text"
        placeholder="parceiro@empresa.com; outro@fornecedor.com"
        class="w-full px-3 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/30"
      />
      <p class="text-xs text-slate-400 leading-snug">
        No chat, o e-mail só pode ser enviado ao utilizador logado, aos destinos do canal E-mail dos agendamentos ativos (quando
        ativos) e a estes endereços.
      </p>
    </div>

    <AgentExecutorSchedulesSection
      ref="executorSchedules"
      :form="form"
      specialty="data_analyst"
      :week-day-options="weekDayOptions"
      :whatsapp-delivery-connector-options="whatsappDeliveryConnectorOptions"
      :data-analyst-source-kind="form.settings?.data_analyst?.data_source_kind || 'api_endpoint'"
      :schedule-api-endpoint-choices="dataAnalystScheduleApiChoices"
      :schedule-database-view-choices="dataAnalystScheduleDbChoices"
    />
  </div>
</template>

<script>
import AgentConnectorEndpoints from './AgentConnectorEndpoints.vue'
import AgentConnectorViews from './AgentConnectorViews.vue'
import AgentExecutorSchedulesSection from './AgentExecutorSchedulesSection.vue'

export default {
  name: 'AgentSpecialtyDataAnalystForm',
  components: { AgentConnectorEndpoints, AgentConnectorViews, AgentExecutorSchedulesSection },
  props: {
    form: { type: Object, required: true },
    filteredApiEndpointOptions: { type: Array, default: () => [] },
    databaseConnectorViewOptions: { type: Array, default: () => [] },
    whatsappDeliveryConnectorOptions: { type: Array, default: () => [] },
    selectedApiEndpointToAdd: { type: [Number, null], default: null },
    selectedDatabaseConnectorViewToAdd: { type: [Number, null], default: null },
    weekDayOptions: { type: Array, default: () => [] }
  },
  emits: [
    'update:selectedApiEndpointToAdd',
    'update:selectedDatabaseConnectorViewToAdd',
    'add-api-endpoint',
    'remove-api-endpoint',
    'add-database-view',
    'remove-database-view'
  ],
  computed: {
    dataAnalystScheduleApiChoices() {
      const allowed = new Set((this.form.api_connector_endpoint_ids || []).map((x) => Number(x)))
      return (this.filteredApiEndpointOptions || []).filter((o) => allowed.has(Number(o.id)))
    },
    dataAnalystScheduleDbChoices() {
      const allowed = new Set((this.form.database_connector_view_ids || []).map((x) => Number(x)))
      return (this.databaseConnectorViewOptions || []).filter((o) => allowed.has(Number(o.id)))
    }
  },
  methods: {
    validateScheduledFixedJson() {
      return this.$refs.executorSchedules?.validateScheduledFixedJsonForRows?.() ?? null
    }
  }
}
</script>
